module.exports = __webpack_public_path__ + "img/dentist-b-shape.9cdc357.png";